function setError(id) {
    $(id).removeClass("is-valid").addClass("is-invalid");
}

function setNormal(id) {
    $(id).removeClass("is-invalid").removeClass("is-valid");
}
//入力されてるかでvalidかどうかセットする
function setValidationStatus(id){
    if ($(id).val().trim().length <= 0) {
        $(id + '_error').text('入力してください');
        setError(id);
    } else {
        setNormal(id);
        $(id + '_error').text('');
    }
}

$(document).ready(function () {
    let isSubmit = false;

    function controllDispPassword() {
        let password = '#password';
        let passcheck = '#js-passcheck';

        $(passcheck).change(function () {
            if ($(this).prop('checked')) {
                $(password).attr('type', 'url');
            } else {
                $(password).attr('type', 'password');
            }
        });

    }
    controllDispPassword();

    // inputクリック時、エラーメッセージを消す
    $('.form-control').on('click', function(){
        let inputId = $(this).attr('id');
        setNormal('#' + inputId);
    });

    $('#orderDetailNumber').on('blur', function () {
        setValidationStatus('#orderDetailNumber');
    });
    $('#password').on('blur', function () {
        setValidationStatus('#password');
    });
    $('#captcha').on('blur', function () {
        setValidationStatus('#captcha');
    });

    $('button[name="verification-submit"]').on('click', function(){
        setValidationStatus('#orderDetailNumber');
        setValidationStatus('#password');
        setValidationStatus('#captcha');

        // エラー箇所へスムーススクロール
        if ($('.is-invalid:first').length) {
            $('.is-invalid:first').focus();
            $("html, body").
                animate(
                    {scrollTop: $('.is-invalid:first').offset().top - 180},
                    200);
            return false;
        }

        // 二度押し防止
        if (isSubmit) {
            return false;
        }
        isSubmit = true;

        $('form[name="orderCheck"]').submit();
    });

});
